<template>
    <transition name="fade">
        <div v-if="isVisible" class="subscription-switch">
            <a
                v-for="subscription in subscriptions"
                :key="subscription.id"
                :class="{current: currentSubscription && subscription.id === currentSubscription.id}"
                href="#"
                @click.prevent="handleClick(subscription)"
            >{{ subscription.name }} License</a>
        </div>
    </transition>
</template>

<script>
import subscritionsList from '@/mixins/subscriptionsList';

export default {
    mixins: [
        subscritionsList,
    ],
};
</script>
